import { toPlatePlugin } from '@udecode/plate/react';

import { BaseFigureCaptionPlugin } from '../lib';

/** Enables support for tables with React-specific features. */
export const FigureCaptionPlugin = toPlatePlugin(BaseFigureCaptionPlugin);
